export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[92vh] w-full items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20long%20flowing%20vibrant%20orange%20hair%20standing%20on%20a%20ship%20deck%20with%20billowing%20white%20sails%20and%20open%20ocean%2C%20warm%20golden%20sunset%20light%2C%20tangerines%20and%20compass%20on%20wooden%20table%2C%20epic%20adventure%20atmosphere%2C%20cinematic%20warm%20color%20palette%2C%20high%20detail%20painterly%20digital%20art%2C%20breathtaking%20hero%20wallpaper&width=1600&height=1000&seq=nami-hero&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 mx-auto flex w-full max-w-5xl flex-col items-center px-4 text-center">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur">
          <i className="ri-windy-line"></i>
          海量娜美同人图与画师作品持续上新
        </span>

        <h1 className="font-heading text-4xl font-bold leading-tight text-background-50 md:text-6xl">
          娜美同人
          <span className="mt-2 block text-2xl font-normal text-background-50/85 md:text-4xl">
            插画 · 壁纸 · 画集精选
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-50/85 md:text-base">
          整理多位娜美同人画师的画集作品,收集温柔的日常、浩瀚的冒险与动人的瞬间。
          高清图片持续更新,满足你的收藏与欣赏需求。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#works"
            className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            立即欣赏作品
            <i className="ri-arrow-down-line"></i>
          </a>
          <a
            href="#collections"
            className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
          >
            浏览系列画集
          </a>
        </div>
      </div>

      <a
        href="#works"
        className="absolute bottom-6 left-1/2 z-10 flex h-10 w-10 -translate-x-1/2 items-center justify-center rounded-full border border-background-50/40 text-background-50 animate-bounce cursor-pointer"
        aria-label="向下浏览"
      >
        <i className="ri-arrow-down-s-line text-xl"></i>
      </a>
    </section>
  );
}